import { v4 as uuidv4 } from 'uuid';
import icon1 from '../../assets/img/icon/process-icon.png';

const detailsCardData = [
    {
        id: uuidv4(),
        icon: icon1,
        num: '01',
        heading: 'Make Discuss',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp',
    },

    {
        id: uuidv4(),
        icon: icon1,
        num: '03',
        heading: 'Sketching',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp',
    },

    {
        id: uuidv4(),
        icon: icon1,
        num: '03',
        heading: 'Design Making',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp',
    },

    {
        id: uuidv4(),
        icon: icon1,
        num: '04',
        heading: 'Product Deliver',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp',
    },
];

export default detailsCardData;
